module.exports = __webpack_public_path__ + "img/Shortlisted_rej.12d9243a.svg";